import { useState } from 'react';
import { css, mediaQuery, useMediaQuery } from 'academy-common-lib/utils/Styling';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { AccordionTransition } from 'foundations-components/transitional/components/AccordionTransition';
import { isPrerenderAgent } from '../../../../utils/prerender';
import { View } from 'foundations-components/components/View';
import styled from 'foundations-theming/utils';
import { DownIcon } from 'foundations-assets/icons/components/DownIcon';
import { UpIcon } from 'foundations-assets/icons/components/UpIcon';

// @bend-expect trellis-tokenized
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const NavGroupHeading = styled.button.withConfig({
  displayName: "FooterNavGroup__NavGroupHeading"
})(["", " ", ""], ({
  theme
}) => ({
  position: 'relative',
  width: '100%',
  textAlign: 'center',
  padding: theme.space['400'],
  fontSize: '18px',
  background: 'none',
  border: 'none',
  color: theme.color['fill-surface-default']
}), mediaQuery('notTablet', css(["text-align:left;padding:0;margin-bottom:16px;cursor:default;"])));

// @bend-expect trellis-tokenized
const FooterLinksWrapper = styled.div.withConfig({
  displayName: "FooterNavGroup__FooterLinksWrapper"
})(["a.footer-link{font-size:14px;}"]);
const FooterNavGroup = ({
  headingText,
  children
}) => {
  const {
    isNotTablet
  } = useMediaQuery();
  const [isOpen, setIsOpen] = useState(false);
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx(FooterLinksWrapper, {
      children: /*#__PURE__*/_jsxs(View, {
        borderBlockEndColor: !isNotTablet ? 'border-tertiary-default' : undefined,
        borderBlockEndStyle: !isNotTablet ? 'solid' : 'none',
        borderBlockEndWidth: !isNotTablet ? '100' : '0',
        children: [/*#__PURE__*/_jsxs(NavGroupHeading, {
          "aria-checked": isOpen,
          onClick: () => setIsOpen(!isOpen),
          role: "switch",
          children: [/*#__PURE__*/_jsx("span", {
            children: headingText
          }), !isNotTablet && /*#__PURE__*/_jsx(IconHolder, {
            icon: isOpen ? UpIcon : DownIcon
          })]
        }), /*#__PURE__*/_jsx(AccordionTransition, {
          open: isOpen || isNotTablet || isPrerenderAgent(),
          children: children
        })]
      })
    })
  );
};
export default FooterNavGroup;